import { HubConnection } from '@microsoft/signalr';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SendWebsocketMessage } from '../../../utils/websocketHelper';

export interface LikeMessageThunkArg {
    connection: HubConnection;
    messageId: number;
    chatId: number;
}

export const likeSupportMessage = createAsyncThunk(
    'supportMessage/sendLike',
    async (arg: LikeMessageThunkArg) => {
        let like = {
            messageId: arg.messageId,
            threadId: arg.chatId,
        };
        await SendWebsocketMessage(arg.connection, 'SR_LikeMessage', like);
    }
);
